import React, {useEffect, useState} from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";

import api from "../../../service/api";

import Header from "../../../components/Header";
import NavTabs from "../../../components/NavTabs";
import Input from "../../../components/Input";
import Button from "../../../components/Button";

import { Row, Column, Legend, Description, GroupEditAndDelete, GroupName } from "./styles";

//Data
import routes from "../../../routes/users.routes";

//Interfaces
import { GroupsInterface } from "../access/interfaces";

//Assets
import pencil from "../../../assets/icons/pencil.svg";
import trash from "../../../assets/icons/trash.svg";

const Groups = () => {
    const [groups, setGroups] = useState<Array<GroupsInterface>>([]);

    const login = useSelector((state: {login: any}) => state.login);
    const history = useHistory();

    useEffect(() => {
        if(login.user.groups.am2a2){
            history.push("/admin/dashboard");
        }
    }, [])

    useEffect(() => {
        const getGroups = async () => {
            const {data} = await api.get("/adm/group");

            setGroups(data);
        }

        getGroups();
    }, []);

    const generateGroups = () => {
        return groups.map(group => {
            return (
                <GroupEditAndDelete key={group.id}>
                    <GroupName>{group.description}</GroupName>
                    <div className="d-flex">
                        { login.user.groups.am2a2u && <img src={pencil} style={{marginRight: 16}}/>}
                        { login.user.groups.am2a2d && <img src={trash} onClick={() => removeGroup(group.id)}/>}
                    </div>
                </GroupEditAndDelete>
            )
        })
    }

    const removeGroup = async (id: string) => {
        try {
            const response = await api.delete(`/adm/group/delete/${id}`)
            const {data} = await api.get("/adm/group");

            setGroups(data);
        } catch (error) {
            
        }
    }

    const formValidationWithYup = Yup.object().shape({
        name: Yup.string().required(),
        description: Yup.string().required()
    })

    return(
        <div>
            <Header title="Usuários" subTitle="Gerencie todos os usuários do sistema" subTitleWidth={174}/>
            <NavTabs tabs={routes}/>

            <Formik
                initialValues={{
                    name: "",
                    description: ""
                }}
                validationSchema={formValidationWithYup}
                onSubmit={async (values) => {
                    try {
                        const response = await api.post("/adm/group", {
                            "description": values.description,
                            "type": values.name,
                            "cm1": false,
                            "cm1u": false,
                            "cm1r1": false,
                            "cm1r2": false,
                            "cm1e": false,
                            "cm2": false,
                            "cm2c": false,
                            "cm2e": false,
                            "cm2r": false,
                            "cm2u": false,
                            "cm2d": false,
                            "cm3": false,
                            "cm3a1": false,
                            "cm3a2": false,
                            "cm3a3": false,
                            "cm4": false,
                            "cm4a1": false,
                            "cm4a2": false,
                            "cm5": false,
                            "cm5a1": false,
                            "cm5a1c": false,
                            "cm5a1e": false,
                            "cm5a1r": false,
                            "cm5a1u": false,
                            "cm5a1d": false,
                            "cm5a2": false,
                            "cm5a2c": false,
                            "cm5a2e": false,
                            "cm5a2r": false,
                            "cm5a2u": false,
                            "cm5a2d": false,
                            "cm5a3": false,
                            "cm6": false,
                            "cm6a1": false,
                            "cm6a1u": false,
                            "cm6a2": false,
                            "cm6a2c": false,
                            "cm6a2u": false,
                            "cm6a3": false,
                            "cm6a3u1": false,
                            "cm6a3u2": false,
                            "cm6a4": false,
                            "cm6a4c1": false,
                            "cm6a4c2": false,
                            "cm6a4c3": false,
                            "cm6a5": false,
                            "cm6a5u1": false,
                            "cm6a5u2": false,
                            "cm7": false,
                            "cm7a1": false,
                            "cm7a2": false,
                        });

                        const {data} = await api.get("/adm/group");
                        
                        setGroups(data);
                    } catch (error) {
                        
                    }
                }}
            >
                {({}) => (
                    <>
                        <Row>
                            <Column>
                                <Form>
                                    <fieldset>
                                        <Legend>Adicionar Grupo</Legend>
                                        <Field id="name" name="name" className="inputCustom" placeholder="Nome" as={Input}/>
                                        <Field id="description" name="description" className="inputCustom" placeholder="Descrição do grupo" as={Input}/>
                                    </fieldset>
                                </Form>
                            </Column>
                            <Column>
                                <Legend>Grupos</Legend>
                                <Description>Lista de grupos ativos no sistema</Description>

                                {generateGroups()}
                            </Column>
                        </Row>
                        <Row>
                            { true && ( //login.user.groups.am2a2c
                                <Form>
                                    <Column>
                                        <Button type="submit">Adicionar Grupo</Button>
                                    </Column>
                                </Form>
                            )}
                        </Row>
                    </>
                )}    
            </Formik>
        </div>
    )
}

export default Groups;